<template>
  <div class="my-guarantor-detail">
    <Header class="header" v-if="showHeader">
      <Menu mode="horizontal" theme="dark" active-name="1" class="top-bar">
        <div class="layout-logo">
          <img src="./../../assets/logo.png" height="42" style="margin-right:10px;">
          <div class="site-name-area">
            <h2 class="inline font-white">{{getConfig('TITLE')}}</h2>
            <div class="small font-grey">{{getConfig('SUBTITLE')}}</div>
          </div>
        </div>
        <div class="layout-nav">
        </div>
        <div class="pull-right" style="margin-right:20px">
          <Tooltip content="登录系统">
            <Button type="text" ghost @click="$router.push('/welcome')" icon="md-exit">登录系统</Button>
          </Tooltip>
        </div>
      </Menu>
    </Header>
    <div :style="showHeader?'padding:16px':''">
      <div class="detail-header">
        <h2>
          {{guarantorModel.name}}
          <Tag v-if="guarantorModel&&guarantorModel.type"
            color="primary">
            {{$common.guarantorType[guarantorModel.type.toString()]}}
          </Tag>
          <Tag v-if="guarantorStatus!==null"
            :color="$common.guarantorStatusColor[guarantorStatus.toString()]">
            {{$common.guarantorStatus[guarantorStatus.toString()]}}
          </Tag>
        </h2>
        <Alert show-icon type="error" v-if="guarantorModel&&guarantorModel.status===40">
          您已被列入黑名单！
          <template slot="desc">
            <p v-if="guarantorModel&&guarantorModel.blacklistReason">
              原因：<span v-html="guarantorModel.blacklistReason"></span>
            </p>
            <p v-if="guarantorModel&&guarantorModel.blacklistFacts">
              违规事实：<span v-html="guarantorModel.blacklistFacts"></span>
            </p>
            <p v-if="guarantorModel&&guarantorModel.blacklistExpires">
              黑名单结束时间：{{require('moment')(guarantorModel.blacklistExpires).format('YYYY-MM-DD')}}
            </p>
          </template>
        </Alert>
        <div class="header-actions">
          <ButtonGroup>
            <Button type="warning" ghost
              v-if="guarantorStatus===3"
              @click="goToStatistics">
              <Icon type="ios-analytics" />
              数据统计</Button>
            <Button type="info" ghost
              v-if="guarantorStatus===3"
              @click="goToGuaranteeList">
              <Icon type="ios-navigate" />
              查看保函</Button>
            <Button type="primary" ghost
              @click="getGuarantorDetail">
              <Icon type="md-refresh" />
              刷新</Button>
            <Button type="warning" ghost
              @click="$router.back()">
              <Icon type="md-arrow-back" />
              返回</Button>
          </ButtonGroup>
        </div>
      </div>
      <div class="detail-body">
        <div v-if="guarantorStatus===-1">
          <Alert type="error" show-icon>
            登记中
            <template slot="desc">
              您已存储草稿，可继续登记
              <Button type="error" :to="`/guarantors/edit/${guarantorModel.id}?own=true`">读取草稿</Button>
            </template>
          </Alert>
        </div>
        <div v-if="guarantorStatus===0">
          <Alert type="error" show-icon>
            请登记
            <template slot="desc">
              还未进行保证人登记
              <Button type="error" to="/guarantors/new">去登记</Button>
            </template>
          </Alert>
        </div>
        <div v-if="guarantorStatus===1">
          <Alert type="warning" show-icon>
            登记预审中
            <template slot="desc">
              您的保证人登记信息正在被预审中，请耐心等待
            </template>
          </Alert>
        </div>
        <div v-if="guarantorStatus===2">
          <Alert type="warning" show-icon>
            登记审核中
            <template slot="desc">
              您的保证人登记信息已通过预审，请打印备案表，携带所有文件进行现场备案。
              <Button type="info" to="/guarantors/preview">打印备案表</Button>
            </template>
          </Alert>
        </div>
        <div v-if="guarantorStatus===99">
          <Alert type="error" show-icon>
            未通过审核
            <template slot="desc">
              很遗憾，您的保证人登记信息未通过审核被退回，请修改后重新提交申请。<br>
              原因：{{guarantorModel.comment}}<br>
              时间：{{guarantorModel.auditTime}}<br>
              <Button type="error" :to="`/guarantors/edit/${guarantorModel.id}?own=true`">修改申请</Button>
            </template>
          </Alert>
        </div>
        <Tabs type="card" class="tab-square" :animated="false" v-if="guarantorModel&&guarantorModel.name" v-model="curTab">
          <TabPane label="基本信息" name="basic">
            <table class="brief-table">
              <tbody>
                <tr>
                  <td class="title">保证人名称</td>
                  <td colspan="3">{{guarantorModel.name}}</td>
                  <td class="title">保证人类型</td>
                  <td v-if="guarantorModel&&guarantorModel.type">{{$common.guarantorType[guarantorModel.type.toString()]}}</td>
                </tr>
                <tr>
                  <td class="title">机构代码</td>
                  <td>{{guarantorModel.code||'未设置'}}</td>
                  <td class="title">审核人</td>
                  <td>{{guarantorModel.auditorName}}</td>
                  <td class="title">审核时间</td>
                  <td>{{guarantorModel.auditTime?require('moment')(guarantorModel.auditTime).format('YYYY-MM-DD HH:mm:ss'):null}}</td>
                </tr>
                <tr v-if="guarantorModel.comment">
                  <td class="title">审核意见</td>
                  <td colspan="5">{{guarantorModel.comment}}</td>
                </tr>
                <tr>
                  <td class="title">社会信用代码</td>
                  <td>{{guarantorModel.businessLicense}}</td>
                  <td class="title">注册资金(万元)</td>
                  <td>{{guarantorModel.capital}}</td>
                  <td class="title">成立日期</td>
                  <td>{{guarantorModel.estDate?require('moment')(guarantorModel.estDate).format('YYYY-MM-DD'):null}}</td>
                </tr>
                <tr>
                  <td class="title">实缴资本(万元)</td>
                  <td>{{guarantorModel.capitalPaidIn}}</td>
                  <td class="title">实缴出资日期</td>
                  <td>{{guarantorModel.capitalPaidInDate?require('moment')(guarantorModel.capitalPaidInDate).format('YYYY-MM-DD'):null}}</td>
                  <td class="title">注册类型</td>
                  <td>{{guarantorModel.corpType}}</td>
                </tr>
                <tr>
                  <td class="title">认缴资本(万元)</td>
                  <td>{{guarantorModel.capitalSubscribed}}</td>
                  <td class="title">认缴出资日期</td>
                  <td>{{guarantorModel.capitalSubscribedDate?require('moment')(guarantorModel.capitalSubscribedDate).format('YYYY-MM-DD'):null}}</td>
                  <td class="title">邮编</td>
                  <td>{{guarantorModel.postCode}}</td>
                </tr>
                <tr>
                  <td class="title">营业地址</td>
                  <td colspan="5">{{guarantorModel.address}}</td>
                </tr>
                <tr v-if="guarantorModel.scope">
                  <td class="title">营业范围</td>
                  <td colspan="5">{{guarantorModel.scope}}</td>
                </tr>
                <tr>
                  <td class="title">公司网址</td>
                  <td colspan="3">{{guarantorModel.homePage}}</td>
                  <td class="title">Email</td>
                  <td>{{guarantorModel.email}}</td>
                </tr>
                <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
                  <td class="title">偿付充足率信息</td>
                  <td colspan="3">{{guarantorModel.solvency}}</td>
                  <td class="title">保证业务总量</td>
                  <td>{{guarantorModel.totalGuaAmount}}万元</td>
                </tr>
                <tr>
                  <td class="title">联系人</td>
                  <td>{{guarantorModel.contact}}</td>
                  <td class="title">电话</td>
                  <td>{{guarantorModel.contactTel}}</td>
                  <td class="title">传真</td>
                  <td>{{guarantorModel.fax}}</td>
                </tr>
                <tr>
                  <td class="title">性别</td>
                  <td>{{guarantorModel.contactGender?'男':'女'}}</td>
                  <td class="title">部门</td>
                  <td>{{guarantorModel.contactDept}}</td>
                  <td class="title">职务</td>
                  <td>{{guarantorModel.contactRole}}</td>
                </tr>
                <tr>
                  <td class="title">法定代表人</td>
                  <td>{{guarantorModel.legalPersonName}}</td>
                  <td class="title" v-if="[2,3,10].indexOf(guarantorModel.type)>-1">电话</td>
                  <td colspan="3" v-if="[2,3,10].indexOf(guarantorModel.type)>-1">{{guarantorModel.legalPersonTel}}</td>
                  <td class="title" v-if="[2,3,10].indexOf(guarantorModel.type)===-1">职务</td>
                  <td v-if="[2,3,10].indexOf(guarantorModel.type)===-1">{{guarantorModel.legalPersonRole}}</td>
                  <td class="title" v-if="[2,3,10].indexOf(guarantorModel.type)===-1">职称</td>
                  <td v-if="[2,3,10].indexOf(guarantorModel.type)===-1">{{guarantorModel.legalPersonTitle}}</td>
                </tr>
                <tr>
                  <td class="title">性别</td>
                  <td>{{guarantorModel.legalPersonGender?'男':'女'}}</td>
                  <td class="title">学历</td>
                  <td>{{guarantorModel.legalPersonEduBackground}}</td>
                  <td class="title">政治面貌</td>
                  <td>{{guarantorModel.legalPersonPolitical}}</td>
                </tr>
                <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
                  <td class="title">管理人员</td>
                  <td>{{guarantorModel.supervisorContactPerson}}</td>
                  <td class="title">电话</td>
                  <td colspan="3">{{guarantorModel.supervisorContactTel}}</td>
                </tr>
                <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
                  <td class="title">管理机构</td>
                  <td>{{guarantorModel.supervisorName}}</td>
                  <td class="title">电话</td>
                  <td colspan="3">{{guarantorModel.supervisorTel}}</td>
                </tr>
                <tr v-if="guarantorModel.type===1">
                  <td class="title">总经理</td>
                  <td>{{guarantorModel.generalManagerName}}</td>
                  <td class="title">职务</td>
                  <td>{{guarantorModel.generalManagerRole}}</td>
                  <td class="title">职称</td>
                  <td>{{guarantorModel.generalManagerTitle}}</td>
                </tr>
                <tr v-if="guarantorModel.type===1">
                  <td class="title">专职从业人员</td>
                  <td>{{guarantorModel.qualifiedTotal}}</td>
                  <td class="title">财务人员</td>
                  <td>{{guarantorModel.cpaTotal}}</td>
                  <td class="title">法务工作人员</td>
                  <td>{{guarantorModel.solicitorTotal}}</td>
                </tr>
                <!-- <tr>
                  <td class="title">员工总数</td>
                  <td>{{guarantorModel.employeeTotal}}</td>
                  <td class="title">有职称</td>
                  <td>{{guarantorModel.titledTotal}}</td>
                  <td class="title">中高级职称</td>
                  <td>{{(guarantorModel.titledMedTotal||0)+(guarantorModel.titledSeniorTotal||0)}}</td>
                </tr>
                <tr>
                  <td class="title">注册监理工程师</td>
                  <td>{{guarantorModel.regSupervTotal}}</td>
                  <td class="title">注册建造师</td>
                  <td>{{guarantorModel.regConstrTotal}}</td>
                  <td class="title">注册造价师</td>
                  <td>{{guarantorModel.regCostTotal}}</td>
                </tr>
                <tr>
                  <td class="title">项目经理</td>
                  <td>{{guarantorModel.prjManagerTotal}}</td>
                  <td class="title">注册会计师</td>
                  <td>{{guarantorModel.cpaTotal}}</td>
                  <td class="title">律师</td>
                  <td>{{guarantorModel.solicitorTotal}}</td>
                </tr> -->
                <tr v-if="guarantorModel.guarRange">
                  <td class="title">担保经营范围</td>
                  <td colspan="6">{{guarantorModel.guarRange}}</td>
                </tr>
                <tr v-if="guarantorModel.introduction">
                  <td class="title" colspan="6">企业简介</td>
                </tr>
                <tr v-if="guarantorModel.introduction">
                  <td colspan="6">{{guarantorModel.introduction}}</td>
                </tr>
              </tbody>
            </table>
          </TabPane>
          <TabPane label="额度信息" name="allowance" v-if="guarantorStatus===3">
            <Row :gutter="16">
              <i-col span="12">
                <i-circle
                  :size="250"
                  :trail-width="4"
                  :stroke-width="5"
                  :percent="getAvaliablePercent"
                  stroke-linecap="square"
                  stroke-color="#43a3fb">
                  <div class="balance-circle">
                    <h1>{{Math.round(calcBalance/10000)/100}}万</h1>
                    <p>已用额度</p>
                    <span>
                      占比
                      <i>{{getAvaliablePercent}}%</i>
                    </span>
                    <p>总额度:{{Math.round(guarantorModel.allowance/10000)/100}}万</p>
                  </div>
                </i-circle>
              </i-col>
              <i-col span="12">
                <Form label-position="right" :label-width="120">
                  <FormItem label="总额度">
                    <!-- <Progress :percent="getAvaliablePercent" :stroke-width="32" text-inside /> -->
                    <span>{{Math.round(guarantorModel.allowance/10000)/100}}万</span>
                  </FormItem>
                  <FormItem label="已用额度">
                    <span>{{Math.round(calcBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateCalculatedBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                  <FormItem label="在保笔数">
                    <span>{{undergoingCount}}</span>
                  </FormItem>
                  <FormItem label="在保担保额度">
                    <span>{{Math.round(undergoingBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateUndergoingBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                  <FormItem label="累计笔数">
                    <span>{{cumulativeCount}}</span>
                  </FormItem>
                  <FormItem label="累计担保额度">
                    <span>{{Math.round(cumulativeBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateCumulativeBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                </Form>
              </i-col>
            </Row>
          </TabPane>
          <TabPane label="附件" name="attachments"
            v-if="(guarantorModel.attachments&&guarantorModel.attachments instanceof Array&&guarantorModel.attachments.length)">
            <div v-for="(att,idx) in guarantorModel.attachments" :key="idx">
              <Divider>{{att.name}}</Divider>
              <div class="attachments">
                <div class="attachment-thumb"
                  :key="idx"
                  v-for="(img,idx) in att.url">
                  <img :src="img.url" @click="handleImgPreview(att.url, idx)" v-if="img&&img.url&&img.type==='image'">
                  <span style="font-weight:bold;color:#999;padding:10px;cursor:pointer" @click="previewImgUrl=img;showPreview=true" v-if="img&&img.url&&img.type==='file'">{{img.surfix.toUpperCase()}}</span>
                </div>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
    <Footer v-if="showHeader" style="text-align:center" />
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null" width="1200">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <iframe :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix==='pdf'" width="100%" height="800"></iframe>
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix!='pdf'">查看</a>
    </Modal>
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import Footer from '@/components/Footer.vue'
export default {
  name: 'my-guarantor-detail',
  props: {
  },
  components: {
    Footer
  },
  data () {
    return {
      showHeader: false,
      loading: false,
      curTab: '',
      guarantorStatus: null,
      guarantorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        legalPersonTel: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        supervisorName: null,
        supervisorTel: null,
        supervisorContactPerson: null,
        supervisorContactTel: null,
        solvency: null,
        totalGuaAmount: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
      },
      calcBalance: null,
      calcCount: null,
      cumulativeBalance: null,
      cumulativeCount: null,
      undergoingBalance: null,
      undergoingCount: null,
      imgUrl: null,
      previewImgUrl: null,
      showPreview: false,
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0
    }
  },
  watch: {
  },
  computed: {
    getAvaliablePercent () {
      if (!this.guarantorModel.allowance || !this.calcBalance) {
        return 0
      }
      return Math.round((this.calcBalance / this.guarantorModel.allowance) * 10000) / 100
    }
  },
  mounted () {
    let verifyObj = document.querySelector('#app > .guarantor-detail')
    if (verifyObj) {
      this.showHeader = true
      try {
        document.body.style = 'overflow: visible !important;'
      } catch (err) {
        console.log(err)
      }
    }
    this.getGuarantorDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    getGuarantorDetail () {
      Api.Guarantor.getMyGuarantorDetail().then((res) => {
        Object.assign(this.guarantorModel, res)
        this.guarantorStatus = this.guarantorModel.status
        this.procAttachmentsOssKeys(this.guarantorModel.attachments)
        if (!this.showHeader) {
          this.getGuarantorBalance()
        }
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
        if (err.message.indexOf('该用户未绑定承保人') > -1) {
          this.guarantorStatus = 0
        }
      })
    },
    async procOssKey (k) {
      try {
        let url = await this.procOSSUrl(k)
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        return {
          name: k,
          url,
          type,
          surfix
        }
      } catch (e) {
        console.log(e)
        return false
      }
    },
    procAttachmentsOssKeys (attaches) {
      attaches.forEach((att) => {
        att.url = []
        if (att.filePath) {
          let keys = att.filePath.split(',')
          keys.forEach(async (k, idx) => {
            att.url[idx] = await this.procOssKey(k)
          })
        }
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    getGuarantorBalance () {
      Api.Guarantee.getCalculatedBalance(this.guarantorModel.id, null, null)
      .then((res) => {
        this.calcBalance = res.amount
        this.calcCount = res.count
      })
      Api.Guarantee.getCumulativeBalance(this.guarantorModel.id, null, null)
      .then((res) => {
        this.cumulativeBalance = res.amount
        this.cumulativeCount = res.count
      })
      Api.Guarantee.getUndergoingBalance(this.guarantorModel.id, null, null)
      .then((res) => {
        this.undergoingBalance = res.amount
        this.undergoingCount = res.count
      })
    },
    updateCalculatedBalance () {
      this.calcBalance = 0
      this.calcCount = 0
      Api.Guarantee.updateCalculatedBalance(this.guarantorModel.id, null, null)
      .then((res) => {
        this.calcBalance = res.amount
        this.calcCount = res.count
      })
    },
    updateCumulativeBalance () {
      this.cumulativeBalance = 0
      this.cumulativeCount = 0
      Api.Guarantee.updateCumulativeBalance(this.guarantorModel.id, null, null)
      .then((res) => {
        this.cumulativeBalance = res.amount
        this.cumulativeCount = res.count
      })
    },
    updateUndergoingBalance () {
      this.undergoingBalance = 0
      this.undergoingCount = 0
      Api.Guarantee.updateUndergoingBalance(this.guarantorModel.id, null, null)
      .then((res) => {
        this.undergoingBalance = res.amount
        this.undergoingCount = res.count
      })
    },
    goToStatistics () {
      this.$router.push({
        name: 'Statistics',
        params: {
          guarantor: this.guarantorModel
        }
      })
    },
    goToGuaranteeList () {
      this.$router.push({
        name: 'guarantee-list',
        params: {
          guarantor: this.guarantorModel
        }
      })
    },
    handleImgPreview (list, index) {
      this.imageUrls = list.map((l) => {return l.url})
      this.visiblePreviewer = true
      this.startPosition = index
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  background: linear-gradient(45deg, #3d3294, #3098ff);
  padding: 0;
}
.top-bar {
  background: transparent;
  padding: 0;
}
.top-bar-search {
  display: inline-block;
  width: 100px;
  margin-right: 20px;
  transition: all linear .3s;
  &.expand {
    width: 300px;
  }
}
.layout-logo {
  height: 50px;
  // background: #5b6270;
  color: #fefefe;
  text-align: center;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 5px;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  .site-name-area {
    line-height: initial;
    text-align: left;
  }
}
.layout-nav{
  margin: 0 auto;
  margin-right: 20px;
  display: inline-block;
}
.detail-header {
  margin-bottom: 40px;
  .header-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
}
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    cursor: pointer;
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>
